var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M17 9.9H6.6a.5.5 0 0 0-.5.5V19a.5.5 0 0 0 .5.5H17a.5.5 0 0 0 .5-.5v-8.6a.5.5 0 0 0-.5-.5M6.6 8.4a2 2 0 0 0-2 2V19a2 2 0 0 0 2 2H17a2 2 0 0 0 2-2v-8.6a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M14.498 8.1v-.9a2.7 2.7 0 1 0-5.4 0v.9zm-2.7-5.1a4.2 4.2 0 0 0-4.2 4.2v2.4h8.4V7.2a4.2 4.2 0 0 0-4.2-4.2",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M10.986 13.636a.818.818 0 1 1 1.636 0v1.637a.818.818 0 1 1-1.636 0z"
  })));
};
export default SvgLock;